import React from 'react';
import { ReactTypeformEmbed } from 'react-typeform-embed';

import { HeaderContainer } from '@spotahome/ui-library';
import { trans, getResourcePath } from '@spotahome/soyuz/client';

import './../../common/scss/init.scss';

import SectionHeading from '../../common/components/SectionHeading';
import Hero from '../../common/components/Hero';
import Footer from '../../common/components/Footer';

import {
  SECTION_HEADING_THEME_DARK,
  SECTION_HEADING_TYPE_NONE
} from '../refer-a-friend/common/constants';

import HowItWorks from './components/HowItWorks';

import './main.scss';

const BuddyUpContainer = () => {
  return (
    <div>
      <Hero
        menu={
          <HeaderContainer
            locales={{ current: 'en' }}
            login={false}
            showMobileMenu={false}
            links={{
              home: false,
              listYourProperty: false,
              howItWorks: false,
              favorites: false
            }}
          />
        }
        title={trans('buddy_up.title')}
        subtitle={trans('buddy_up.description')}
        size="big"
        colorTitle="dark"
        colorSubtitle="dark"
        isRowAlignContent
        className="hero__wrapper--fit"
        image={getResourcePath(
          '/images/refer-a-friend/referral-illustration.svg'
        )}
      />
      <div>
        <SectionHeading
          text={trans('external.buddyUp.form-title')}
          theme={SECTION_HEADING_TYPE_NONE}
          type={SECTION_HEADING_THEME_DARK}
        />
        <div className="typeForm__form">
          <ReactTypeformEmbed url="https://spotahome-secure.typeform.com/to/S0WrGV" />
        </div>
      </div>
      <HowItWorks />
      <Footer />
    </div>
  );
};

export default BuddyUpContainer;
